export const CarrierIconsList = {
    C_CHEZ_VOUS: 'c_chez_vous',
    CHRONOPOST: 'chronopost',
    COLISSIMO: 'colissimo',
    MONDIAL_RELAY: 'mondial_relay',
    DPD: 'dpd',
    KUEHNE_NAGEL: 'kuehne_nagel',
    CLICK_COLLECT: 'click_and_collect',

    toArray() {
        return Object.values(this).filter(value => typeof value === 'string');
    }
}